import React, { useState } from 'react'
import { useQueryClient } from "@tanstack/react-query";
import { baseUrl } from '../../utils/apiActions/dashboardApi';
import { Button } from 'react-bootstrap';
import { toastError, toastSuccess } from '../../utils/toastrResponse';
import { useFetchData } from '../../hooks/useFetchData';
import Locations from '../Locations';
import useAxios from '../../hooks/useAxios';

const AssignUserLocation = ({ hide,setStep,userId }) => {
  const locations = JSON.parse(localStorage.getItem("locations"));
    const [locationId, setLocationId] = useState(locations[locations.length -1]?.id);
    const [groupId, setGroupId] = useState();
  const user = JSON.parse(localStorage.getItem("user"));
  const queryClient = useQueryClient();
  const axiosInstance = useAxios()
  // Assign user to a locations
  const assingUserToLocation = async (e) => {
    e.preventDefault();
    try {
      const dataToSend = {
        locationId,
        userId,
      };
      const url = `${baseUrl}/users/${userId}/locations`;
      const assignLocation = await axiosInstance({
        url,
        method: "POST",
        headers:{
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data:dataToSend,
      });

      const assignGroup = await axiosInstance({
        url:`/users/${userId}/groups`,
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data:{
          userId,
          groupId,
        },
      });
      if (
        assignGroup.status >= 200 &&
        assignGroup.status < 300 &&
        assignLocation.status >= 200 &&
        assignLocation.status < 300
      ) {
        setStep(0);
        toastSuccess("Location and group Assigned to a user");
        hide();
        queryClient.invalidateQueries(["fetch-users"]);
      } else {
        toastError("Could not assign location to user");
      }
    } catch (error) {
      console.log(error);
    }
  };
  // Fetch groups
  const { data: userGroups } = useFetchData(["fetch-groups"], "users/groups",true);
  const handleDataFromLocationsComponent = (data) => {
    setLocationId(data?.locationId);
  };
  return (
    <div>
      <form className='mt-5' onSubmit={assingUserToLocation}>
        <div className='d-flex justify-content-center'>
          <h5>Set group</h5>
        </div>
        <div
          className='locations-container'
          style={{ flexDirection: "column" }}
        >
          <label className='ml-2'>User Group</label>
          <select
            name='groups'
            className='form-control input-select mb-2'
            onChange={(e) => setGroupId(e.target.value)}
          >
            <option value=''>--select group--</option>
            {userGroups?.map((group) => (
              <option key={group?.id} value={group?.id}>
                {group?.name}
              </option>
            ))}
          </select>
        </div>
        <div className='d-flex justify-content-center mt-3'>
          <h5>Set locations</h5>
        </div>
        <Locations
          sendDataToParent={handleDataFromLocationsComponent}
          flexDirection='column'
        />
        <div className='d-flex justify-content-center'>
          <Button className='custom-btn-color' type='submit'>
            Save Location
          </Button>
        </div>
      </form>
    </div>
  );
}

export default AssignUserLocation